// extracted by mini-css-extract-plugin
export default {"container":"I2-z"};